import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import {BrowserRouter} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
// ** Import custom components for redux **
import {Provider} from 'react-redux';
import {PersistGate} from "redux-persist/integration/react";
import {persistStore} from "redux-persist";
import store from '../src/store';
import MainRoutes from "./routes";
import axios from 'axios';
import { api_base_url } from './config/config'
import { setSessionStorage } from "./helper/CommonFunctions";
import path from './routes/path';
import './lang/i18n';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import {userData} from './config/sessionKeys'
import ApiUrlServices from "./networks/ApiUrlServices";
import {S3_Pool_conf} from "./config/aws-amplify";
import { Amplify } from 'aws-amplify'
import FBMessenger from "./component/fbMessanger/FBMessenger";
import {messengerChatId} from "./config/config";
const qs = require('query-string');
let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));

Amplify.configure(S3_Pool_conf);

axios.interceptors.request.use(request => {
    // console.log(request);

    if (request.url.includes("course/courses/get_permission") && request.method === "post") {
        request.headers.withCredentials = true;
    }
    // Edit request config
    return request;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.request.use(request => {
    // Edit request config
    let usersData = JSON.parse(localStorage.getItem(userData));
    request.headers['Authorization'] = `Bearer ${usersData?.idToken}`;
    return request;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error?.response?.status === 401 || error?.response?.data?.code === "USER_NOT_MENTOR") {
        // console.log(error.response.data.code)
        let usersData = JSON.parse(localStorage.getItem(userData));
        const refreshToken = usersData.refreshToken;
        return axios.post(`${api_base_url}${ApiUrlServices.REFRESH_TOKEN}`,
            {
                "refresh_token": refreshToken
            })
            .then(response => {
                usersData["accessToken"] = response.data.data.accessToken
                usersData["idToken"] = response.data.data.idToken

                setSessionStorage(userData, usersData)

                error.response.config.headers['Authorization'] = `Bearer ${response.data.data.idToken}`;
                return axios(error.response.config);
            })
            .catch(error => {
                if (error.response.data.code !== "TOKEN_EXPIRED") {
                    return;
                }
                localStorage.clear()
                document.cookie.split(";").forEach(function (c) {
                    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                });

                let myDynamicPath = "";
                const parsed = qs.parse(window.location.search);
                if (Object.entries(parsed).length) {
                    for (const [key, value] of Object.entries(parsed)) {
                        if (!key || !value) {
                            continue;
                        }
                        myDynamicPath = myDynamicPath + `&${key}=${value}`;
                    }
                }
                window.location = path.login + `?redirect_to=${window.location.pathname}${myDynamicPath}`;
            });
    }
    return Promise.reject(error);
});

root.render(
    // <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter basename={`/`}>
                    <ToastContainer/>
                    <MainRoutes/>
                    <FBMessenger page_id={messengerChatId}/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    // </React.StrictMode>
);

// **************** Author: Bokhtyer Abid || bokhtyer.abid@shadhinlab.com *************** //
// **************** React 17 *************** //
// ReactDOM.render(<Root/>, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
